import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums, PaperSizeEnums } from 'src/app/enum/formats-enums';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CompanyEnums } from './../../../../enum/company-enums';

@Component({
  selector: 'app-register-format',
  templateUrl: './register-format.component.html',
  styleUrls: ['./register-format.component.scss'],
  standalone: false
})
export class RegisterFormatComponent implements OnInit, OnDestroy {

  companyId: number = 0;
  companyIdForDetail: number = 0;
  disabledDetail: boolean = false;
  formFormat: FormGroup = new FormGroup({});
  formatContract: FormatModel = new FormatModel();
  formatId: number = 0;
  listCompany: any[] = [];
  listPaperSize: any[] = [];
  nameWindow: string = 'Configuración de Formatos';
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  updateListDetail: boolean = false;
  url: string = "format";

  constructor(private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private headerService: HeaderService,
    private router: Router,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(this.formatContract);
  }

  async ngOnInit() {
    //Se comenta ya que no se puede crear desde esta ventana
    // this.getCompanyByUserAutheticated();
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.formatId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getAllLists();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeCode() {
    const companyId = this.formFormat.get("companyId")?.value;
    if (companyId === null || companyId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una compañía.'
      );
      return;
    }

    let code = this.formFormat.get("code")?.value;
    if (code < 0 || code === null || code.toString().trim() === "") code = 0;

    if (code === 0) {
      this.resetForm(companyId);
    } else {
      try {
        this.formatContract = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(companyId, code));
        this.formatId = this.formatContract.formatId;
        this.validateForm(this.formatContract);
        this.location.replaceState(`/format/register/${this.formatId}`);
      } catch (error) {
        this.resetForm(companyId);
        console.error("Error al obtener el formato por código:", error);
      }
    }
  }

  changeCompany(companyId: number | null) {
    if (companyId === 0 || companyId === null) {
      this.formFormat.controls["companyId"].patchValue(0);
      this.formatId = 0;
      this.validateForm(new FormatModel());
      this.location.replaceState(`/format/register`);
    } else {
      this.companyIdForDetail = companyId;
      this.formatId = 0;
      const modelFormat = new FormatModel();
      modelFormat.companyId = companyId;
      this.validateForm(modelFormat);
      this.location.replaceState(`/format/register`);
    }
  }

  changePaperSize(paperSize: number) {
    const head = paperSize === PaperSizeEnums.letter ? 220 : 120;
    const foot = paperSize === PaperSizeEnums.letter ? 250 : 90;
    this.formFormat.controls["head"].patchValue(head);
    this.formFormat.controls["foot"].patchValue(foot);
  }

  createFormat() {
    if (this.companyId == CompanyEnums.altosSoftware) {
      this.formatContract = new FormatModel();
      this.formatContract.code = 0;
      this.formatId = 0;
      this.validateForm(this.formatContract);
      this.disabledDetail = true;
      this.quantityDetails = 0;
      setTimeout(() => this.formFormat.controls["code"].disable(), 100);
      this.location.replaceState(`/format/register`);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'Solo está permitido crear formatos en la compañía principal.'
      );
    }
  }

  async deleteFormat() {
    if (this.formatContract.formatId !== 0 && this.formatContract.formatId !== null) {
      if (this.companyId === CompanyEnums.altosSoftware) {
        this.toastHandlerService.showToast(
          'error',
          'Solo está permitido eliminar formatos en la compañía principal.'
        );
        return;
      }
      if (await this.confirmDialogService.confirm('Al eliminar este formato, se eliminará para todas las compañías ¿Realmente desea eliminar el formato actual?')) {
        try {
          await firstValueFrom(this.formatService.deleteFormat(this.formatContract.formatId));
          this.createFormat();
          this.toastHandlerService.showToast(
            'success',
            'El formato fue eliminado exitosamente.'
          );
        } catch (error) {
          console.error("Error al eliminar el formato: ", error);
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un formato.'
      );
      return;
    }
  }

  async getAllLists(...listsToLoad: Array<'companies' | 'paperSizes'>) {
    try {
      const lists = {
        companies: async () => {
          this.listCompany = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
        },
        paperSizes: async () => {
          this.listPaperSize = await firstValueFrom(this.formatService.getAllPaperSizesForSelectAsync());
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.companies(),
          lists.paperSizes()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const companyId = this.formFormat.get("companyId")?.value;
    if (companyId === null || companyId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una compañía.'
      );
      return;
    }

    let code = this.formFormat.get("code")?.value;
    if (code < 0 || code == "" || code == null) code = 0;

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.formatContract = await firstValueFrom(this.formatService.getFirstFormatByKeysAsync(companyId));
          this.validateForm(this.formatContract);
          this.formatId = this.formatContract.formatId;
          this.location.replaceState(`/format/register/${this.formatId}`);
        } catch (error) {
          this.resetForm(companyId);
          console.error('Error al obtener el primer formato por claves:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.formatContract = await firstValueFrom(this.formatService.getPreviusFormatByKeysAsync(companyId, code));
          this.validateForm(this.formatContract);
          this.formatId = this.formatContract.formatId;
          this.location.replaceState(`/format/register/${this.formatId}`);
        } catch (error) {
          this.resetForm(companyId);
          console.error('Error al obtener el formato anterior por claves:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.formatContract = await firstValueFrom(this.formatService.getNextFormatByKeysAsync(companyId, code));
          this.validateForm(this.formatContract);
          this.formatId = this.formatContract.formatId;
          this.location.replaceState(`/format/register/${this.formatId}`);
        } catch (error) {
          this.resetForm(companyId);
          console.error('Error al obtener el formato siguiente por claves:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.formatContract = await firstValueFrom(this.formatService.getLastFormatByKeysAsync(companyId));
          this.validateForm(this.formatContract);
          this.formatId = this.formatContract.formatId;
          this.location.replaceState(`/format/register/${this.formatId}`);
        } catch (error) {
          this.resetForm(companyId);
          console.error('Error al obtener el último formato por claves:', error);
        }
        break;
      }
    }
  }

  async getCompanyByUserAutheticated() {
    try {
      this.companyId = (await firstValueFrom(this.companyService.getCompanyByUserAutheticated())).companyId;
    } catch (error) {
      console.error('Error al obtener la compañía del usuario autenticado.', error);
    }
  }

  async getFormatById() {
    try {
      this.formatContract = await firstValueFrom(this.formatService.getFormatById(this.formatId));
      this.validateForm(this.formatContract);
      this.location.replaceState(`/format/register/${this.formatId}`);
    } catch (error) {
      console.error("Error al obtener el formato por ID:", error);
    }
  }

  getUpdateListDetail() {
    this.updateListDetail = !this.updateListDetail;
  }

  async handleInitialState() {
    if (this.formatId !== null && this.formatId !== 0) {
      await this.getFormatById();
    } else {
      this.createFormat();
    }
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
  }

  goToBack() {
    if (this.formatId && this.formatId > 0) {
      this.router.navigate([`/format/${this.formatId}`]);
    } else {
      this.router.navigate([`/format`]);
    }
  }

  resetForm(companyId: number) {
    this.formatId = 0;
    this.formatContract = new FormatModel();
    this.formatContract.companyId = companyId;
    this.validateForm(this.formatContract);
    this.location.replaceState(`/format/register`);
  }

  async send() {
    Object.keys(this.formFormat.controls).forEach(key => {
      const control = this.formFormat.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formFormat.valid) {
      const modelFormat = this.formFormat.getRawValue() as FormatModel;

      if (this.formatId === 0) {
        if (this.formatId === 0 || this.formatContract.formatId === 0 || modelFormat.formatId === 0) {
          this.toastHandlerService.showToast(
            'error',
            'No es posible crear formatos desde esta ventana, comuniquese con el área de desarrollo.'
          );
          return;
        }
        // Se evita crear formatos desde esta ventana para evitar inconvenientes al no tener configuracion de html
        if (modelFormat.companyId !== CompanyEnums.altosSoftware) {
          this.toastHandlerService.showToast(
            'error',
            'Solo está permitido crear formatos en la compañía principal.'
          );
          return;
        }
        try {
          this.formatContract = await firstValueFrom(this.formatService.createFormat(modelFormat));
          this.formatId = this.formatContract.formatId;
          this.validateForm(this.formatContract);
          this.location.replaceState(`/format/register/${this.formatId}`);
          this.toastHandlerService.showToast(
            'success',
            'El Formato fue creado exitosamente.'
          );
        } catch (error) {
          console.error('Error al crear el Formato.', error);
        }
      } else {
        if (this.formatContract.companyId === CompanyEnums.altosSoftware &&
          !await this.confirmDialogService.confirm(`Actualizar este formato modificará todos los formatos de ${modelFormat.name} del sistema. ¿Desea continuar?`)) {
          return;
        }
        this.formatContract.name = modelFormat.name;
        this.formatContract.head = modelFormat.head;
        this.formatContract.body = modelFormat.body;
        this.formatContract.foot = modelFormat.foot;
        this.formatContract.group = modelFormat.group;
        this.formatContract.paperSizeId = modelFormat.paperSizeId;
        try {
          this.formatContract = await firstValueFrom(this.formatService.updateFormat(this.formatContract));
          this.validateForm(this.formatContract);
          this.toastHandlerService.showToast(
            'success',
            'El Formato fue modificado exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar el Formato.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'El campo Compañía es obligatorio.',
        min: 'Debe ingresar una Compañía válida.'
      },
      code: {
        required: 'El campo Número es obligatorio.',
        min: 'Debe ingresar un Número mayor a cero.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El nombre no puede tener más de 250 caracteres.'
      },
      head: {
        required: 'El campo Head es obligatorio.'
      },
      body: {
        required: 'El campo Body es obligatorio.'
      },
      foot: {
        required: 'El campo Foot es obligatorio.'
      },
      paperSizeId: {
        required: 'El campo Tamaño Papel es obligatorio.',
        min: 'Debe ingresar un Tamaño Papel válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formFormat.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(format: FormatModel) {
    this.formFormat = this.formBuilder.group({
      companyId: [format.companyId, [Validators.required, Validators.min(1)]],
      code: [format.code, [Validators.required, Validators.min(1)]],
      name: [format.name, [Validators.required, Validators.maxLength(250)]],
      head: [format.head, [Validators.required]],
      body: [format.body, [Validators.required]],
      foot: [format.foot, [Validators.required]],
      group: [format.group],
      paperSizeId: [format.paperSizeId, [Validators.required, Validators.min(1)]]
    });
    if (format.code == FormatsEnums.invoice || format.code == FormatsEnums.preinvoicing || format.code == FormatsEnums.notes ||
      format.code == FormatsEnums.valuedEquipmentLogbook || format.code == FormatsEnums.simpleEquipmentLogbook || format.code == FormatsEnums.chargeAccount) {
      setTimeout(() => this.formFormat.controls["group"].enable(), 100);
    } else {
      setTimeout(() => this.formFormat.controls['group'].disable(), 100);
    }

    //Se inhabilita el campo head para evitar problemas con la altura del header al generar el pdf de Interfaz Factura Electronica
    if (format.companyId == CompanyEnums.altosSoftware) {
      if (format.code == FormatsEnums.invoice || format.code == FormatsEnums.notes) {
        setTimeout(() => this.formFormat.controls["head"].disable(), 100);
      } else {
        setTimeout(() => this.formFormat.controls['head'].enable(), 100);
      }
    }

  }

}
